require('normalize.css/normalize.css');

import React from 'react';
import {tabImages} from './common';


class Tab extends React.Component {

  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const iconType = this.props.active === this.props.name ? 'active' : 'normal';
    return (
      <div
        className = "tab"
      >
        <img src={tabImages[this.props.name][iconType]} />
      </div>
    );
  }
}

export default Tab;



// WEBPACK FOOTER //
// ./src/components/Tab.js